import { IKeyNumberDict } from "@/types/GlobalTypes";
import { isNullOrEmpty } from "./commonMobile";

function getDTCardValue(card: string) {
	if (isNullOrEmpty(card))
		throw new Error("card cannot be empty");

	return card[0] in specialCardLetters
		? specialCardLetters[card[0]]
		: Number(card[0]);
}


const specialCardLetters: IKeyNumberDict = {
	A: 1,
	T: 10,
	J: 11,
	Q: 12,
	K: 13
};

export {
	getDTCardValue,
	specialCardLetters
}